import React, { useContext } from 'react';
import { getContext } from 'common';
import { ListContext } from './List';

import Styled from './styles';

// TODO: replace Styled.Divider with <HorizontalDivider />
/** All props will be provided to the wrapper element. */
const ListDivider = React.forwardRef<HTMLElement, React.ComponentPropsWithRef<'li'>>((props: React.ComponentPropsWithRef<'li'>, ref) =>
  getContext(({ RTL }) => {
    const listContext = useContext(ListContext);
    return (
      <Styled.Divider RTL={RTL} $theme={listContext.theme} ref={ref} role="presentation" {...props} />
    );
  }));

ListDivider.displayName = 'ListDivider';

export default ListDivider;
